import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  FormInput,
  Modal,
  ModalBody,
  ModalHeader,
  Row
} from "shards-react";
import { db } from "../../firebase";
import "../admin/userDetails/tab.css";
import { collection, doc, onSnapshot, updateDoc } from "firebase/firestore";

function DeviceData() {
  const [devices, setDevices] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [deviceDocId, setDeviceDocId] = useState("");
  const [pixelfor1mm, setPixelFor1mm] = useState("");
  const [mmfor1Pixel, setmmFor1Pixel] = useState("");
  const [deviceOffset, setDeviceOffset] = useState("");
  const [dataUpdateLoading, setDataUpdateLoading] = useState("");
  const [dataUpdateResponse, setDataUpdateResponse] = useState("");
  const DevicesRef = React.useRef(devices);

  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, "DeviceData"), data => {
      data.docChanges().forEach(async change => {
        if (change.type === "added") {
          setDevices(prevDevices => [
            ...prevDevices,
            { uid: change.doc.id, ...change.doc.data() }
          ]);
        }
        if (change.type === "modified") {
          let newArray = [...DevicesRef.current];
          let index = newArray.findIndex(
            device => change.doc.id === device.uid
          );
          newArray[index] = { uid: change.doc.id, ...change.doc.data() };
          setDevices(newArray);
        }
        if (change.type === "removed") {
          let newArray = [...DevicesRef.current];
          let index = newArray.findIndex(
            device => change.doc.id === device.uid
          );
          newArray.splice(index, 1);
          setDevices(newArray);
        }
      });
    });
    return unsubscribe;
  }, []);

  useEffect(() => {
    DevicesRef.current = devices;
  }, [devices]);

  const pagination = paginationFactory({
    sizePerPage: 50,
    hideSizePerPage: true
  });

  const columns = [
    {
      dataField: "deviceId",
      text: "Device Id",
      sort: true
    },
    {
      dataField: "model",
      sort: true,
      text: "Model"
    },
    {
      dataField: "os",
      text: "OS",
      sort: true
    },
    {
      dataField: "dimensions",
      text: "Dimensions",
      formatter: (cell, row) => {
        return (
          <>
            <p className="mb-0">Width : {cell.width ? cell.width : ""}</p>
            <p className="mb-0">Height : {cell.height ? cell.height : ""}</p>
            <p className="mb-0">
              Pixel Density : {cell.pixelDensity ? cell.pixelDensity : ""}
            </p>
          </>
        );
      }
    },
    {
      dataField: "mmfor1Pixel",
      sort: true,
      text: "mm for 1 Pixel"
    },
    {
      dataField: "pixelfor1mm",
      sort: true,
      text: "Pixel for 1 mm"
    },
    {
      dataField: "deviceOffset",
      sort: true,
      text: "Device Offset"
    },
    {
      isDummyField: true,
      dataField: "",
      text: "Action",
      formatter: (cell, row) => {
        return (
          <button
            type="button"
            className="btn btn-info"
            style={{ zIndex: 1 }}
            onClick={() => updateDeviceDataModel(row)}
          >
            Edit
          </button>
        );
      }
    }
  ];

  const updateDeviceDataModel = row => {
    setModalVisible(!modalVisible);
    setDeviceDocId(row && row.uid);
    setmmFor1Pixel(row && row.mmfor1Pixel ? row.mmfor1Pixel : "");
    setPixelFor1mm(row && row.pixelfor1mm ? row.pixelfor1mm : "");
    setDeviceOffset(row && row.deviceOffset ? row.deviceOffset : "");
    setDataUpdateLoading(false);
    setDataUpdateResponse("");
  };

  const updateDeviceDetails = async () => {
    try {
      setDataUpdateLoading(true);
      if (deviceDocId !== "") {
        setDataUpdateResponse("");
        let deviceDocRef = doc(db, "DeviceData", deviceDocId);
        await updateDoc(deviceDocRef, {
          mmfor1Pixel: parseFloat(mmfor1Pixel),
          pixelfor1mm: parseFloat(pixelfor1mm),
          deviceOffset: parseFloat(deviceOffset)
        });
        setDataUpdateResponse("Updated");
      } else {
        setDataUpdateResponse("Try again.");
        alert("Something went wrong");
      }
    } catch (error) {
      setDataUpdateResponse("Try again.");
      setDataUpdateLoading(false);
    }
  };

  const SearchBar = props => {
    return (
      <input
        className="form-control"
        type="text"
        onChange={e => {
          props.onSearch(e.target.value);
        }}
      />
    );
  };

  return (
    <Container fluid className="main-content-container px-4">
      <Row className="page-header py-4">
        <Col>
          <Card small className="mb-4">
            <CardBody className="p-0 pb-3">
              <ToolkitProvider
                keyField="uid"
                data={devices}
                columns={columns}
                bootstrap4
                search
              >
                {props => (
                  <div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "15px 20px"
                      }}
                    >
                      <h6 className="m-0 font-weight-bold">Devices</h6>
                      <div className="w-45">
                        <SearchBar {...props.searchProps} />
                      </div>
                    </div>
                    <BootstrapTable
                      pagination={pagination}
                      {...props.baseProps}
                    />
                  </div>
                )}
              </ToolkitProvider>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Modal open={modalVisible} toggle={updateDeviceDataModel}>
        <ModalHeader>Update Device Data</ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <label htmlFor="#mmfor1px" className="mb-2">
                mm For 1 Pixel
              </label>
              <FormInput
                id="#mmfor1px"
                placeholder="mm for 1 Pixel"
                type="number"
                value={mmfor1Pixel}
                onChange={e => setmmFor1Pixel(e.target.value)}
              />
            </FormGroup>
            <FormGroup>
              <label htmlFor="#pxform1mm" className="mb-2">
                Pixel For 1 mm
              </label>
              <FormInput
                id="#pxform1mm"
                placeholder="Pixel for 1 mm"
                type="number"
                value={pixelfor1mm}
                onChange={e => setPixelFor1mm(e.target.value)}
              />
            </FormGroup>
            <FormGroup>
              <label htmlFor="#deviceOffset" className="mb-2">
                Device Offset
              </label>
              <FormInput
                id="#deviceOffset"
                placeholder="Device Offset"
                type="number"
                value={deviceOffset}
                onChange={e => setDeviceOffset(e.target.value)}
              />
            </FormGroup>
            {dataUpdateLoading && dataUpdateResponse !== "" && (
              <p className="text-center mt-2">{dataUpdateResponse}</p>
            )}
          </Form>
          <div className="d-flex justify-content-evenly">
            <button
              type="button"
              className="btn btn-success"
              onClick={() => updateDeviceDetails()}
            >
              Update
            </button>
            <button
              type="button"
              className="btn btn-warning"
              onClick={() => updateDeviceDataModel("")}
            >
              Close
            </button>
          </div>
        </ModalBody>
      </Modal>
    </Container>
  );
}

export default DeviceData;
